// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__622SJ","header":"ReportDetails_header__1fIbH","title":"ReportDetails_title__J8bly","left":"ReportDetails_left__y-8hj"};